module.exports = __webpack_public_path__ + "fonts/fontello.6b9c2a8.ttf";